import { ResponsiveBar } from '@nivo/bar';
import React from 'react';
import { ChartBase } from 'src/features/boards/components/Analytics/ChartBase';

const VelocityChart = ({ data }: { data: any }) => {
  // Transform data for the chart
  const chartData = data
    ? Object.keys(data).map((key) => ({
        sprint: data[key].name,
        commited: data[key].total - data[key].completed,
        completed: data[key].completed,
      }))
    : [];

  const chartObject = [
    {
      type: 'line',
      chart: (
        <ResponsiveBar
          data={chartData}
          keys={['completed', 'commited']}
          indexBy="sprint"
          margin={{ top: 50, right: 50, bottom: 50, left: 50 }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            legend: 'Story points',
            legendPosition: 'middle',
            legendOffset: -40,
          }}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            legend: 'Sprint',
            legendPosition: 'middle',
            legendOffset: 60,
            tickRotation: -45,
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          animate={true}
          padding={0.8}
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          colors={['#3DD456', '#D3DBF8']}
          borderRadius={5}
          axisTop={null}
          axisRight={null}
          enableLabel={false}
        />
      ),
    },
  ];

  return (
    <ChartBase
      data={chartObject}
      noData={chartData.length < 0}
      title="🎯&nbsp;Sprint velocity"
      emptyStateTextArray={[
        'No data to show',
        'Set task estimates and fill timesheet data for accurate burn-up data',
      ]}
      // datepicker={datepicker}
      infoLabel="Calculated based on the task estimates and the timelogs recorded for each task"
    />
  );
};

export default VelocityChart;
